import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import {
  useUnitWeightsControllerGetUnitWeightsQuery,
  useUnitWeightsSetControllerSetUnitWeightsMutation,
} from '@shared/services/apiService/apiService';
import { UnitWeightsFormValue } from '../model/type';

export const useUnitWeights = () => {
  const { data, isLoading } = useUnitWeightsControllerGetUnitWeightsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [setUnitWeights, { isLoading: isSaving }] =
    useUnitWeightsSetControllerSetUnitWeightsMutation();

  const formMethods = useForm<UnitWeightsFormValue>({
    mode: 'all',
    defaultValues: { weights: [] },
  });

  const { reset, formState } = formMethods;

  useEffect(() => {
    if (data) {
      reset({
        weights: data.map((item) => ({
          id: item.id,
          sourceUnit: item.sourceUnit as unknown as string,
          limitUnit: item.limitUnit as unknown as string,
          weight: item.weight,
        })),
      });
    }
  }, [data, reset]);

  const onSubmit = formMethods.handleSubmit(async (formData) => {
    const defaultWeights = formState.defaultValues?.weights ?? [];

    const changedWeights = formData.weights.filter(
      (item, index) => item.weight !== defaultWeights[index]?.weight,
    );

    if (!changedWeights.length) return;

    await setUnitWeights({
      unitWeightsSetRequestDto: {
        weights: changedWeights.map(({ id, weight }) => ({ id, weight })),
      },
    }).unwrap();

    reset(formData);
  });

  return {
    formMethods,
    onSubmit,
    isLoading,
    isSaving,
    isDirty: formState.isDirty,
  };
};
